
export function objectUrlToBlob(objectUrl) {
    return new Promise((resolve, reject) => {
        fetch(objectUrl)
            .then(response => {
                if (response.ok) {
                    return response.blob();
                }
                throw new Error('Сетевой ответ не ok.');
            })
            .then(blob => resolve(blob))
            .catch(error => reject(error));
    });
}

export async function blobToDataUrl(blob) {
    return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = () => {
            resolve(reader.result);
        };
        reader.onerror = reject;
        reader.readAsDataURL(blob);
    });
}

export async function dataUrlToImageSize(dataUrl) {
    return new Promise((resolve, reject) => {
        const image = new Image();
        image.onload = () => {
            resolve({ width: image.width, height: image.height });
        };
        image.onerror = reject;
        image.src = dataUrl;
    });
}

export async function blobToImageSize(blob) {
    return new Promise((resolve, reject) => {
        const image = new Image();
        const objectUrl = URL.createObjectURL(blob);

        image.onload = () => {
            resolve({ width: image.width, height: image.height });
            URL.revokeObjectURL(objectUrl);
        };
        image.onerror = () => {
            reject(new Error('Ошибка при загрузке изображения'));
            URL.revokeObjectURL(objectUrl);
        };

        image.src = objectUrl;
    });
}

export function scaleToHeight(size, targetHeight) {
    var aspectRatio = size.width / size.height;
    var newWidth = aspectRatio * targetHeight;

    return { width: newWidth, height: targetHeight };
};